import { render } from "./IconSettings.vue?vue&type=template&id=ccbdb2d0"
import script from "./IconSettings.vue?vue&type=script&lang=js"
export * from "./IconSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__